import cn from 'classnames';
import { Button } from 'components/Button';
import {  rm } from 'utils';
import { getQaDataAttr } from '@bygghemmait/utilities';
import styles from './styles.scss';

interface Props {
  url: string;
  quantity: number;
  className?: string;
}

export const BasketButton = ({ url, quantity, className }: Props) => (
  <Button
    textTransform="uppercase"
    href={url}
    appearance="tertiary"
    className={cn(styles.basketButton, className)}
    {...getQaDataAttr('checkout-header')}
  >
    {rm('shared_minibasket_navigation_next')}
    {quantity > 0 && <>&nbsp;({quantity})</>}
  </Button>
);
